import { render, staticRenderFns } from "./main-slider.html?vue&type=template&id=e5435492&scoped=true&"
import script from "./main-slider.vue?vue&type=script&lang=js&"
export * from "./main-slider.vue?vue&type=script&lang=js&"
import style0 from "./main-slider.css?vue&type=style&index=0&id=e5435492&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5435492",
  null
  
)

export default component.exports